import { useRouter } from 'next/router';

import { Locale, RouterService } from '../core';

import { RouteLink } from './RouteLink';
import { useRouteInfo } from './useRouteInfo';
import { useRouteNavigation } from './useRouteNavigation';

const toFullLocale = (shortLocale?: string): Locale => {
  if (shortLocale?.startsWith('de')) {
    return 'de-CH';
  }
  return 'fr-FR';
};

const useDefaultUseLocale = (): Locale => {
  const router = useRouter();
  return toFullLocale(router.locale);
};

export const init = (
  options: Omit<
    Parameters<typeof RouterService.init>[0],
    'RouteLink' | 'useRouteInfo' | 'useRouteNavigation'
  >
) => {
  return RouterService.init({
    RouteLink,
    useRouteInfo,
    useRouteNavigation,
    useLocale: useDefaultUseLocale,
    ...options,
  });
};
